enum AlertType {
	PRICE_COMPARISON = 'PRICE_COMPARISON',
	COMPETITORS_PRICE_RATE = 'COMPETITORS_PRICE_RATE',
	PARITY_PRICE_COMPARISON = 'PARITY_PRICE_COMPARISON',
	COMPETITORS_SOLD_OUT = 'COMPETITORS_SOLD_OUT'
}

export default AlertType;